import { render } from "./Home.vue?vue&type=template&id=3f0cf74d&scoped=true"
import script from "./Home.vue?vue&type=script&lang=js"
export * from "./Home.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-3f0cf74d"

export default script